import React from 'react';
import { motion } from 'framer-motion';
export function WhatIsEbook() {
  return <section className="py-20 md:py-28 bg-matrix-black relative overflow-hidden px-6 md:px-8" data-id="element-188">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-matrix-green/5 via-transparent to-transparent" data-id="element-189"></div>

      <div className="max-w-xl mx-auto relative z-10 text-center" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-191">
          <h2 className="font-cinzel text-3xl md:text-5xl text-matrix-cream mb-4 drop-shadow-[0_0_10px_rgba(245,230,200,0.15)] tracking-wide" data-id="element-192">
            ¿QUÉ ES ESTE EBOOK?
          </h2>

          <div className="w-16 h-[2px] bg-matrix-green/60 mx-auto mb-10 md:mb-14 rounded-full" data-id="element-193"></div>

          <p className="text-base md:text-lg text-matrix-white/85 font-light leading-[1.9] md:leading-[2] mb-8" data-id="element-194">
            <span className="text-matrix-cream font-medium italic" data-id="element-195">
              "¿Estás listo para jugar?"
            </span>{' '}
            es un ebook de crecimiento personal y espiritualidad creado para
            ayudarte a cuestionar creencias limitantes, ampliar tu visión de la
            realidad y comenzar un proceso consciente de despertar interior.
          </p>

          <p className="text-base md:text-lg text-matrix-white/85 font-light leading-[1.9] md:leading-[2]" data-id="element-196">
            Más que una lectura, es una invitación a mirar más allá de lo
            evidente, reflexionar sobre tu camino y reconectar con una versión
            más despierta, libre y auténtica de ti.
          </p>
        </motion.div>
      </div>
    </section>;
}